import { baseApi } from "./baseApi";

export const tradingSettingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAlpacaTradingSettings: builder.query({
      query: () => ({
        url: "/trading-settings/alpaca",
        method: "GET",
      }),
      providesTags: ["User"],
    }),
    saveAlpacaTradingSettings: builder.mutation({
      query: (body) => ({
        url: "/trading-settings/alpaca",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    deleteAlpacaTradingSettings: builder.mutation({
      query: () => ({
        url: "/trading-settings/alpaca",
        method: "DELETE",
      }),
      invalidatesTags: ["User"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAlpacaTradingSettingsQuery,
  useSaveAlpacaTradingSettingsMutation,
  useDeleteAlpacaTradingSettingsMutation,
} = tradingSettingsApi;
